import { put, takeLatest, call } from 'redux-saga/effects';
import {
  GET_BORROWER_DASHBOARD_DATA,
  SET_BORROWER_DASHBOARD_DATA,
  GET_INVESTOR_DASHBOARD_DATA,
  SET_INVESTOR_DASHBOARD_DATA,
  SEND_SMS,
  SEND_PUBLIC_SMS,
  VERIFY_PHONE_NUMBER,
  VERIFY_PHONE_NUMBER_SUCCESS,
  VERIFY_PHONE_NUMBER_ERROR,
} from '../redux/action/types';
import { areaApi } from '../utils/api';

function* getBorrowerDashboardData() {
  try {
    const dashboardData = yield areaApi.getBorrowerDashboardData();
    yield put({
      type: SET_BORROWER_DASHBOARD_DATA,
      data: dashboardData.data,
    });
  } catch (err) {
    console.log(err);
  }
}

function* getInvestorDashboardData() {
  try {
    const dashboardData = yield areaApi.getInvestorDashboardData();
    yield put({
      type: SET_INVESTOR_DASHBOARD_DATA,
      data: dashboardData.data,
    });
  } catch (err) {
    console.log(err);
  }
}

function* sendSms(action) {
  try {
    yield areaApi.sendSms(action.data);
  } catch (err) {
    console.log(err);
  }
}

function* sendPublicSms(action) {
  try {
    yield areaApi.sendPublicSms(action.data);
  } catch (err) {
    console.log(err);
  }
}

function* verifyPhoneNumber(action) {
  try {
    const response = yield call(() => areaApi.verifyPhoneNumber(action.data.data));
    if (response && response.status === 200) {
      yield put({
        type: VERIFY_PHONE_NUMBER_SUCCESS,
        data: response.data,
      });
      if (action.data.onSuccess) {
        action.data.onSuccess(response.data);
      }
    }
  } catch (err) {
    console.log(err);
    // Try to extract error message from different possible locations
    const errorMessage =
      err?.data?.message ||
      err?.response?.data?.message ||
      'verification_error';
    yield put({
      type: VERIFY_PHONE_NUMBER_ERROR,
      error: errorMessage,
    });
    if (action.data.onError) {
      action.data.onError(errorMessage);
    }
  }
}

function* dashboardSaga() {
  yield takeLatest(SEND_SMS, sendSms);
  yield takeLatest(SEND_PUBLIC_SMS, sendPublicSms);
  yield takeLatest(VERIFY_PHONE_NUMBER, verifyPhoneNumber);
  yield takeLatest(GET_BORROWER_DASHBOARD_DATA, getBorrowerDashboardData);
  yield takeLatest(GET_INVESTOR_DASHBOARD_DATA, getInvestorDashboardData);
}

export default dashboardSaga;
